import React from 'react';
import { useLandingSettings } from '../useLandingSettings';
import { PLUS_BENEFITS } from '../content';

const interFont = { fontFamily: 'Inter, sans-serif' };

const ArrowBullet: React.FC = () => (
  <span
    className="flex shrink-0 items-start justify-center"
    style={{ color: 'var(--color-primary, #143b6b)' }}
  >
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M7 17 17 7M8 7h9v9" />
    </svg>
  </span>
);

export const PlusBenefits: React.FC = () => {
  const { secondary } = useLandingSettings();
  const hasSecondary = Boolean(secondary?.trim());

  return (
    <section className="px-4 md:px-8">
      <div className="mx-auto max-w-[1180px]">
        <h2
          className="mx-auto max-w-[1100px] text-center font-['Inter'] text-[clamp(2.25rem,4vw,58px)] font-light leading-[1.04] text-[#23262C]"
          style={interFont}
        >
          Welcome to a Better Health Coverage Experience for Individuals and
          Families
        </h2>

        <div
          className={`mt-14 grid items-stretch gap-[38px] max-[1200px]:gap-8 md:auto-rows-fr ${
            hasSecondary ? 'md:grid-cols-2' : ''
          }`}
        >
          {hasSecondary && (
            <div className="aspect-square overflow-hidden rounded-[28px] md:aspect-auto">
              <img
                src={secondary}
                alt=""
                className="h-full w-full object-cover"
              />
            </div>
          )}
          <div className="flex h-full flex-col rounded-[28px] bg-[#f5eee2] p-8 md:p-10">
            <h3
              className="font-['Inter'] text-[clamp(1.75rem,2.5vw,33px)] font-semibold leading-[1.08] text-[#23262C]"
              style={interFont}
            >
              With OneHealth Plus you get:
            </h3>
            <ul className="mt-7 space-y-5">
              {PLUS_BENEFITS.map((item) => (
                <li key={item} className="flex gap-3.5">
                  <ArrowBullet />
                  <span
                    className="font-['Inter'] text-base sm:text-[clamp(1.125rem,1.8vw,21px)] font-normal leading-[1.18] text-[#55585f]"
                    style={interFont}
                  >
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
